import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { PAGE_TYPES } from "../../../constants/rto-constants";
import isObjectEmpty from "../../../utils/helpers/isObjectEmpty";
import { BodyText } from "@cars24/turbo-web/lib/body-text";
import { Table } from "@cars24/turbo-web/lib/table";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import {Heading} from "@cars24/turbo-web/lib/heading";
import { NUMBER } from "../../../constants/app-constants";

const heading = [
    {
        "label": "Year",
        "key": "year"
    },
    {
        "label": "Vehicle registration",
        "key": "vehicleRegCount"
    }
];

const RtoVehInfoVehSellingDetails = ({
    pageType,
    vehicleSellingDetail
}) => {
    const { tokens } = useTokens();
    const { vehicleSold, h1, h2 } = vehicleSellingDetail || {};

    if (pageType !== PAGE_TYPES.STATE || isObjectEmpty(vehicleSellingDetail || {})) return null;
    return (
        <div styleName={"styles.sellingDetailsContainer"}>
            <Heading level={NUMBER.TWO} fontWeight="semibold" color={tokens.text_default_text_primary}>{h1}</Heading>
            <div styleName={"styles.contentWrapper"}>
                <BodyText level={NUMBER.ONE} color={tokens.text_default_text_secondary}>{h2}</BodyText>
            </div>
            <Table
                isExpandable={false}
                isStriped={true}
                heading={heading}
                data={vehicleSold}
                color={tokens.text_default_text_primary}
                stripColor={tokens.background_surface_default_surface_secondary}
            />
        </div>
    );
};

RtoVehInfoVehSellingDetails.propTypes = {
    pageType: PropTypes.string,
    vehicleSellingDetail: PropTypes.object
};

export default RtoVehInfoVehSellingDetails;
